import React from "react";
import { Draggable } from "react-beautiful-dnd";
import DragHandlerIcon from "@atlaskit/icon/glyph/drag-handler";

import path from "ramda/src/path";

import { EnhancedTableRow } from "../../components/EnhancedTableRow";
import { DraggableTableCell } from "../../components/DraggableTableCell";
import { Switch } from "../../components/Switch";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { disclaimerFormatter, tagFormatter } from "../../helpers/disclaimerFormatter";
import { Box } from "../../UI/Box";
import { TableRowOptions } from "../TableRowOptions";

import useAuth from "../../routes/login/AuthContext";

interface IAnswer {
  answerText: string;
}

interface IProps {
  idx: number;
  id: string;
  showTagColumn?: any;
  questionText: string;
  retainAnswer: boolean;
  disclaimer: string;
  answers: IAnswer[];
  handleEdit: VoidFunction;
  tag?: {
    name: string;
    id: number;
  };
  handleDelete: VoidFunction;
  editDisabled: boolean;
  toggleRetainAnswer: VoidFunction;
  isLoading: boolean;
}

export const SliderQuestionsTableBodyRow: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();

  return (
    <Draggable index={props.idx} draggableId={"" + props.id} isDragDisabled={isSuperAdminRead() || props.editDisabled}>
      {(propvided, snapshot) => (
        <EnhancedTableRow {...propvided.draggableProps} ref={propvided.innerRef} isDragging={snapshot.isDragging}>
          <DraggableTableCell {...propvided.dragHandleProps} isDragOccurring={snapshot.isDragging}>
            <ReadOnlyWrapper>
              <Box width={32} height={32} display="flex" alignItems="center" justifyContent="center">
                <DragHandlerIcon label="Drag icon" size="large" />
              </Box>
            </ReadOnlyWrapper>
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>{props.questionText}</DraggableTableCell>
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>
            {path(["answers", 0, "answerText"], props)}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>
            {path(["answers", 1, "answerText"], props)}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>
            {disclaimerFormatter(props.disclaimer)}
          </DraggableTableCell>
          {props.showTagColumn && (
            <DraggableTableCell isDragOccurring={snapshot.isDragging}>{tagFormatter(props.tag?.name)}</DraggableTableCell>
          )}
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>
            <TableRowOptions handleEdit={props.handleEdit} handleDelete={props.handleDelete} editDisabled={props.editDisabled} ><Switch
              isDisabled={isSuperAdminRead() || props.editDisabled}
              switchProps={{
                checked: props.retainAnswer,
                onChange: props.toggleRetainAnswer,
              }}
            /> </TableRowOptions>
          </DraggableTableCell>
        </EnhancedTableRow>
      )}
    </Draggable>
  );

};